import { sendAppMessage, MobileAppBus } from '@helpers/mobileApp';
import { IconBrandGoogle } from '@tabler/icons-react';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/ui/Modal';
import { useEffect, useState } from 'react';
import { useOAuthMutation } from '@http';
import { toast } from 'react-toastify';
import { useAppStore } from '@stores';

export function GoogleSignIn() {
  const [notFound, setNotFound] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'GoogleSignIn' });
  const { mutateAsync } = useOAuthMutation();
  const { userData, refetch } = useAppStore();

  useEffect(() => {
    MobileAppBus.addEventListener('googleSignIn', (idToken: string) => {
      postServer(idToken);
    });
  }, []);

  const postServer = async (code: string) => {
    const data = await mutateAsync({ type: 'google', code });

    if (!data) {
      return toast(t('error'), { type: 'error' });
    }

    if (data.jwt) {
      localStorage.setItem('authToken', data.jwt);
      return window.location.reload();
    }

    if (data.notFound) {
      return setNotFound(true);
    }

    refetch();
  };

  const startLogin = () => {
    sendAppMessage('googleSignIn');
  };

  if (userData.googleSub) {
    return (
      <Button className="text-primary">
        <div className="flex w-full items-center">
          <IconBrandGoogle size={18} />
          <p className="ml-2">{t('connected')}</p>
        </div>
      </Button>
    );
  }

  return (
    <>
      <Modal onRequestClose={() => setNotFound(false)} isOpen={notFound}>
        <p className="text-center text-red-500 my-4">{t('notFound')}</p>
      </Modal>

      <Button onClick={startLogin}>
        <div className="flex w-full items-center">
          <IconBrandGoogle size={18} />
          <p className="ml-2">{t('button')}</p>
        </div>
      </Button>
    </>
  );
}